// Usage: calculateFreight(postcode, length, width, height, weight)
// Data file: data.json

import data from './data.json';

function calculateFreight(postcode, length, width, height, weight) {
  const pc = String(postcode).trim();

  // 计算用重量 = MAX(体积重, 实际重量)
  const volWeight = (length * width * height) / 4000;
  const calcWeight = Math.max(volWeight, weight);
  const ceilWt = Math.ceil(calcWeight);

  // 查分区
  const zone = data.zones[pc];
  if (!zone) return { error: 'Postcode not found', postcode: pc };

  // 查运费费率
  const r = data.rates[zone];
  if (!r) return { error: 'Zone rate not found', postcode: pc, zone };

  // 基础运费 = MAX(basic + ceil(weight)*perKg, minCharge) * (1+fuelRate)
  const calc = r.basic + ceilWt * r.perKg;
  const base = (calc > r.minCharge ? calc : r.minCharge) * (1 + data.fuel);

  // 附加费 = MAX(电商附加费, 超长附加费)
  let ecomm = 0, lenSur = 0;
  for (const [max, charge] of data.ecomm) {
    if (calcWeight <= max) { ecomm = charge; break; }
  }
  for (const [max, charge] of data.length) {
    if (length <= max) { lenSur = charge; break; }
  }
  const surcharge = Math.max(ecomm, lenSur);

  // 偏远附加费
  let remote = 0;
  const rem = data.remote[pc];
  if (rem) remote = rem[0] + rem[1] * ceilWt;

  const total = base + surcharge + remote;

  return {
    postcode: pc,
    zone,
    calcWeight: +calcWeight.toFixed(4),
    ceilWeight: ceilWt,
    basicCharge: r.basic,
    perKg: r.perKg,
    minCharge: r.minCharge,
    baseFreight: +base.toFixed(4),
    ecommSurcharge: ecomm,
    lengthSurcharge: lenSur,
    surcharge,
    remoteSurcharge: +remote.toFixed(4),
    totalFreight: +total.toFixed(4)
  };
}

// 适配器函数，匹配其他快递公司的接口: (postcode, weight, length)
// 假设默认宽度和高度为 30cm
export const calculateShipping = (postcode, weight, length, width = 30, height = 30) => {
  const result = calculateFreight(postcode, length, width, height, weight);

  // 如果有错误，返回一个很大的值
  if (result.error) {
    return 999999;
  }

  return result.totalFreight;
};

// 导出详细计算函数供需要的地方使用
export { calculateFreight };

/*
使用说明
1. calculateShipping(postcode, weight, length, [width], [height]) - 简化接口，返回运费总额
2. calculateFreight(postcode, length, width, height, weight) - 详细接口，返回完整计算信息
3. 参数说明: postcode=邮编, length=长(cm), width=宽(cm), height=高(cm), weight=重量(kg)
4. 燃油附加费率: 30.9% (如需更新请修改 JSON 中的 fuel 字段)
5. 电商附加费: ≤22kg→$7.2, ≤55kg→$15.5, ≤90kg→$48, >90kg→$96
6. 超长附加费: ≤119cm→$0, ≤199cm→$5.4, ≤225cm→$15.5, >225cm→$240
7. 运费公式: MAX(Basic+⌈重量⌉*PerKg, MinCharge)*(1+燃油率) + MAX(电商,超长) + 偏远附加
*/
